<template>
<div class="h-100 d-none d-lg-block">
    <div class="w-100 bg-secondary text-white px-3 py-2 mb-3">Category</div>
    <div class="multilevel-menu" style="height: calc(100% - 56px)">        
        <ul >
            <li v-for="category in $page.props.categories" :key="category.id">
                <inertia-link :href="this.route('products',{id:category.id})">{{category.category_name}}

                <i class="fas fa-chevron-right float-right"  v-if="category.children"></i>
                </inertia-link>
                <ul v-if="category.children">
                    <li v-for="child in category.children" :key="child.id">
                        <inertia-link :href="this.route('products',{id:child.id})">
                        {{child.category_name}}
                        <i class="fas fa-chevron-right float-right"  v-if="child.children"></i>
                        </inertia-link>
                        <ul class="parent" v-if="child.children">
                            <li v-for="child2 in child.children" :key="child2.id">
                                <inertia-link :href="this.route('products',{id:child2.id})">
                                    {{child2.category_name}}
                                    <i class="fas fa-chevron-right float-right"  v-if="child2.children"></i>                              
                                </inertia-link>

                                <ul class="child" v-if="child2.children">
                                    <li v-for="child3 in child2.children" :key="child3.id">
                                        <inertia-link :href="this.route('products',{id:child3.id})">
                                        {{child3.category_name}}
                                        </inertia-link>
                                    </li>
                                </ul>

                            </li>
                        </ul>
                    </li>
                </ul>
            </li>
        </ul>
    </div>
</div>
</template>
<script>

    export default {
        mounted(){
            $('.child').hide(); //Hide children by default

            $('.parent').children().hover(function (event) {
                event.preventDefault();
                $(this).children('.child').slideToggle('fast');
                $(this).find('span').toggle();
            });
        }
    }
</script>  